// Setup operations utilities for SetupMode

import { v4 as uuidv4 } from 'uuid';


export const validateCoordinates = (lat, lng) => {
  return !isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
};


export const createLocationPoint = (latitude, longitude, index, type = 'NORMAL') => {
  return {
    id: uuidv4(),
    name: `${index}`,
    latitude,
    longitude,
    type
  };
};

export const resetSetupData = (setLocations, setStartId, setPath, currentModeRef, isSetupMode) => {
  // Clear location points
  setLocations([]);
  // Clear start point
  setStartId('');
  // Clear all paths
  if (setPath && currentModeRef && isSetupMode(currentModeRef.current)) {
    setPath([]);
  }
}; 